import React from 'react';
import { StyledContainer } from './InputContainer.styled';
export const InputContainer = ({
  children,
  status,
  isDisabled
}) => {
  return React.createElement(StyledContainer, {
    status: status,
    isDisabled: isDisabled
  }, children);
};